import { Link } from "components/elements";
import { TableRowColumn, TableSubRow } from "components/layout";
import { ActionMenu, MenuItem } from "components/popups";
import { RestrictedArea, ROLES } from "containers/Permissions";
import { TiVoDeviceClientType } from "hooks/tivoDevices";
import { pathToUrl } from "utils/url";

import { PATHS } from "../../constants";
import { TEXTS } from "../constants";
import styles from "../TiVoDevices.scss";

interface TiVoDeviceSubRowProps {
  clientType: TiVoDeviceClientType;
  oemId: string;
  platformId: string;
}

export function TiVoDeviceSubRow({
  clientType,
  oemId,
  platformId,
}: TiVoDeviceSubRowProps) {
  return (
    <TableSubRow>
      <TableRowColumn className={styles.clientName}>
        <Link
          to={pathToUrl(PATHS.detailsClientType, {
            platformId,
            oemId,
            clientTypeId: clientType.id,
          })}
        >
          {clientType.name}
        </Link>
      </TableRowColumn>
      <TableRowColumn>{clientType.slug}</TableRowColumn>
      <TableRowColumn>
        <ActionMenu>
          <MenuItem
            to={pathToUrl(PATHS.detailsClientType, {
              platformId,
              oemId,
              clientTypeId: clientType.id,
            })}
          >
            {TEXTS.MENU.CLIENT_DETAILS}
          </MenuItem>
          <RestrictedArea
            allowed={[ROLES.tivoDevices.admin]}
            showFallback={false}
          >
            <MenuItem
              to={pathToUrl(PATHS.editClientType, {
                platformId,
                oemId,
                clientTypeId: clientType.id,
              })}
            >
              {TEXTS.MENU.CLIENT_EDIT}
            </MenuItem>
          </RestrictedArea>
        </ActionMenu>
      </TableRowColumn>
    </TableSubRow>
  );
}
